export function getProgressColor(percentage) {
  if (percentage > 90) return 'error';
  if (percentage > 75) return 'warning';
  return 'success';
}
